import $ from 'jquery';
window.jQuery = $
window.$ = $

$(document).ready(function () {
    $(".select_address_btn").click(function () {
        console.log('click')
        $('.form_option').removeClass('hidden');
        $('.select_address_btn').addClass('hidden');
        $('.add_address_btn').removeClass('hidden');
        $('.use_address_btn').removeClass('hidden');
    });
});